<ng-container caLocalizationScope="search-nav">
  <div class="m-0 ms-sm-4 mt-sm-2 mb-sm-5 me-sm-2 d-flex align-items-center">
    <p data-automation-id="search-error">
      {{ 'searchError' | caLocalize }}
      <span class="link link-primary" (click)="openDrawer()">{{ 'contactSupport' | caLocalize }}</span>
    </p>
  </div>
</ng-container>
